import { Menu } from "antd";
import { useEffect, useState } from "react";
import "./MainLayout.css";
import { useLocation, useNavigate } from "react-router-dom";
import type { MenuProps } from "antd";
import { useUser } from "../Context/UserContext";
import analytics from "../images/analytics.svg";
import "../Common/MainLayout.css";
import {
  AnalyticsIcon,
  AttendanceIcon,
  CompanyIcon,
  ContactsIcon,
  DashboardIcon,
  FinanceIcon,
  LmsIcon,
  NotificationIcon,
  PhoneIcon,
  ReportsIcon,
  SettingsIcon,
  StudentsIcon,
} from "../images/icons/IconSvg";
import { userData, userIsAuthenticated } from "../Store/Slice/userSlice";
import { useSelector } from "react-redux";
import { RoleTypes } from "../Generated/orval-apis/cit.schemas";
import { ScheduleOutlined } from "@ant-design/icons";
export interface IAccessCodes {
  enquiries: string;
  students: string;
  curriculums: string;
  streams: string;
  classes: string;
  paymentMedium: string;
  credentials: string;
  documents: string;
  holidays: string;
  status: string;
  medium: string;
  role: string;
  attendance: string;
  fees: string;
  settings: string;
  feesType: string;
  counselor: string;
  // enquiryLead: string;
  lms: string;
  assessment: string;
  request: string;
  reports: string;
  callLogs: string;
  gradeBook: string;
}
export const AccessCodes: IAccessCodes = {
  enquiries: "564ABCD9C82C7705502477FD72385B057CF0",
  students: "D1C5FDE72EC230CD9E41CD1A035B1CFDDBA7c",
  curriculums: "F87D82327A49BEC0D61423696FD2A2348620",
  streams: "304B5FD57DD964F77FC910E727A2AA4F1983",
  classes: "18680A4D96329F1B47BF0D55097C914853F4",
  paymentMedium: "33831E7576C023614D405FD2D8AAD607778A",
  credentials: "194B46C6ACEBB78AEC6B97AE8E88ED90B368",
  documents: "DAA778971D60505FC8E46C93FAC42427BD09",
  holidays: "49500E4B07434838F287FF38AB8CB401CD27",
  status: "DDF2F8ACA18D5033D2618EC4B3C269AA45F0",
  medium: "71CE908A8A04C5F0527C2FE1FC4CFDF3C3E9",
  role: "B57927C05FB853D8665A97C38B9CBF892B97",
  attendance: "FDE87E74337FAAD2EF979DCDBA4C1280E07E",
  fees: "353E4192939291799CC23C27B57C6FB02037",
  settings: "C561F0626055218D84C1E92FFFAE8A7AEB3C",
  feesType: "610c5b106c81c8bddc03f6a1c0e1f07721d14f",
  counselor: "cad4e23b1e6cc159da09920a9b927a89b24f30",
  lms: "610c5b156c81c8bddc03f6a1c0e1f07721d18f",
  assessment: "610c5b106c91c8bddc03f6a1c0e1h07721d14f",
  request: "610c5b106c91c8bddc03f6a1c0e1h07721abcd",
  reports: "610c5b106c91c8bddc03f6a1c0e1h07721efgh",
  callLogs: "610c5b106c91c8bddc03f6a1yhr1h07721efgh",
  gradeBook: "210c5b106c91c8bffc03f6a1yhr1h07721jsgh",
};
const Sidemenus: React.FC<any> = (props) => {
  const { isCollapse } = props;
  const loc = useLocation();
  // const { isAuthenticated } = useUser();
  const isAuthenticated = useSelector(userIsAuthenticated);
  // const rights: IAccessCodes = JSON.parse(
  //   localStorage.getItem("tp-user") + ""
  // )?.rights;
  let rights: IAccessCodes | undefined | null = useSelector(userData)?.rights;

  const [current, setCurrent] = useState(
    loc.pathname === "/" ? "/" : `/${loc.pathname.split("/")[1]}`
  );

  useEffect(() => {
    if (loc && current !== loc.pathname) {
      setCurrent(`/${loc.pathname.split("/")[1]}`);
    }
  }, [loc, current]);

  const navigate = useNavigate();
  const setSelectedMenuItem = (key: any) => {
    if (key) {
      navigate(key);
      props.onsetSlide(false);
      setCurrent(key);
    }
  };

  const [openKeys, setOpenKeys] = useState([""]);
  const rootSubmenuKeys = ["Basic", "Study"];
  const onOpenChange: MenuProps["onOpenChange"] = (keys) => {
    const latestOpenKey: any = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey, "sub1"] : []);
    }
  };

  type MenuItem = Required<MenuProps>["items"][number];
  const getItem = (
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[]
  ): MenuItem => ({
    key,
    icon,
    children,
    label,
  });

  const getMenuIconWrapper = (
    icon: React.ReactNode,
    menuKey: string,
    activeColor: boolean = false
  ) => (
    <div
      style={{
        display: "flex",
        flexDirection: isCollapse ? "column" : "row",
        color:
          activeColor && current.split("/")[1] === menuKey ? "#0D61FF" : "",
      }}
    >
      {icon}
    </div>
  );

  const renderMenuItem = (
    rightKey: keyof IAccessCodes,
    accessCode: string,
    label: string,
    key: string,
    icon: React.ReactNode,
    children?: MenuItem[]
  ) => {
    return rights?.[rightKey] === accessCode
      ? getItem(label, key, getMenuIconWrapper(icon, key), children)
      : null;
  };

  const EmployeeItems: MenuProps["items"] = [
    getItem(
      "Dashboard",
      "dashboard",
      getMenuIconWrapper(<DashboardIcon />, "dashboard")
    ),

    renderMenuItem(
      "enquiries",
      AccessCodes.enquiries,
      "Enquiries",
      "enquiries",
      <ContactsIcon />,
      [
        getItem("All Enquiries", "enquiry"),
        getItem("Lead Management", "lead-management"),
      ]
    ),

    renderMenuItem(
      "students",
      AccessCodes.students,
      "Students",
      "student",
      <StudentsIcon />
    ),

    renderMenuItem("lms", AccessCodes.lms, "LMS", "lms", <LmsIcon />, [
      getItem("Subject Allocation", "subject-allocation"),
      getItem("Manage Schedule", "manage-schedule"),
    ]),

    renderMenuItem(
      "assessment",
      AccessCodes.assessment,
      "Assessments",
      "assessments",
      <AnalyticsIcon />,
      [
        getItem("Assessments & Evaluation", "assessments-grades"),
        getItem("Exams", "exams"),
        rights?.gradeBook === AccessCodes.gradeBook
          ? getItem("Academic Records", "gradebook")
          : null,
      ]
    ),

    renderMenuItem(
      "attendance",
      AccessCodes.attendance,
      "Attendance",
      "attendance",
      <AttendanceIcon />
    ),

    renderMenuItem(
      "request",
      AccessCodes.request,
      "Requests",
      "requests",
      <ScheduleOutlined
        className={
          current.split("/")[1] === "requests"
            ? "menu-icon-active"
            : "menu-icon-default"
        }
      />
    ),

    renderMenuItem(
      "reports",
      AccessCodes.reports,
      "Reports",
      "reports",
      <ReportsIcon />
    ),

    renderMenuItem(
      "fees",
      AccessCodes.fees,
      "Finance",
      "finance",
      <FinanceIcon />,
      [getItem("Payment", "fees")]
    ),

    renderMenuItem(
      "callLogs",
      AccessCodes.callLogs,
      "Call Logs",
      "call-logs",
      <PhoneIcon />
    ),

    getItem(
      "Notice",
      "notice",
      getMenuIconWrapper(<NotificationIcon />, "notice")
    ),

    renderMenuItem(
      "settings",
      AccessCodes.settings,
      "Settings",
      "settings",
      <SettingsIcon />
    ),
  ];

  const studentItems: MenuProps["items"] = [
    getItem("Exam", "exam", getMenuIconWrapper(<DashboardIcon />, "exam")),
    getItem(
      "Results",
      "results",
      getMenuIconWrapper(<img src={analytics} alt="" />, "results")
    ),
  ];

  const SuperAdminItems: MenuProps["items"] = [
    getItem(
      "Company",
      "company",
      getMenuIconWrapper(<CompanyIcon />, "company")
    ),
  ];

  const userRoleType = useSelector(userData)?.roleType;

  return isAuthenticated ? (
    <Menu
      style={{
        backgroundColor: "white",
        transition: "all 0.6s ease",
        position: "relative",
        width: "100%",
        overflowY: "auto",
        height: isCollapse ? `calc(100vh - 170px)` : `calc(100vh - 120px)`,
        top: "12px",
      }}
      mode="inline"
      className="sidebar"
      defaultSelectedKeys={[current]}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      selectedKeys={[current.split("/")[1]]}
      onClick={(e) => setSelectedMenuItem(e.key)}
      items={
        userRoleType === RoleTypes.Student
          ? studentItems
          : userRoleType === RoleTypes.SuperAdmin
          ? SuperAdminItems
          : EmployeeItems
      }
    />
  ) : null;
};

export default Sidemenus;
